module.exports = __webpack_public_path__ + "img/img2.e386aae5.jpg";